module.exports = __webpack_public_path__ + "static/media/toast.66b15967.png";